import { render, staticRenderFns } from "./PublicHolidays.vue?vue&type=template&id=40dd3090&scoped=true&"
import script from "./PublicHolidays.vue?vue&type=script&lang=js&"
export * from "./PublicHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd3090",
  null
  
)

export default component.exports